module.exports = __webpack_public_path__ + "media/images/features/6/schedule-2-1faf59c7d829900b6d43cb39864e6965.png";